/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import Text from '../../ts-components/Text'

/**
 * Props for the SectionHeader component
 */
export interface SectionHeaderProps {
  /** Section label text (e.g., "Today", "Earlier") */
  label: string
  /** Flag indicating if this is the "Earlier" section for additional styling */
  isEarlier?: boolean
}

/**
 * SectionHeader component - renders date group headers for notifications
 * Used to separate notifications into sections like "TODAY" and "EARLIER"
 *
 * @param {SectionHeaderProps} props - Component props
 * @returns {JSX.Element} Section header with styled label
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({
  label,
  isEarlier = false,
}) => {
  return (
    <div
      css={css`
        margin-bottom: 8px;
        ${isEarlier ? 'margin-top: 16px;' : ''}
      `}
    >
      <Text
        variant='paragraphXSmall'
        weight='semiBold'
        color={colors.NEUTRAL_50}
        style={`
        text-transform: uppercase;
        letter-spacing: 0.5px;
      `}
      >
        {label}
      </Text>
    </div>
  )
}

export default SectionHeader
